import { Navigate, useParams } from "react-router"

/**
 * Las direcciones de cuando «Comercial» fue un departamento con pestañas, y antes el
 * «Catálogo».
 *
 * ⚠ **Comercial es una SECCIÓN del menú, no una pantalla.** Agrupa módulos sueltos
 * —clientes, cotizaciones, proveedores, tipos de proveedor—, igual que «Operaciones» o
 * «Finanzas». Durante unas horas del 05/10 fue un departamento con pestañas en
 * `/comercial`; se deshizo porque lo que agrupa a estas pantallas es el área que las usa,
 * no una pantalla que las contenga.
 *
 * ⚠ **De aquella forma quedan direcciones vivas, y conservan la VISTA.**
 * `/comercial/proveedores` y `/catalogo/proveedores` abren proveedores, no la primera de
 * la lista: caer a la primera lleva a otra pantalla sin decir nada, y quien guardó el
 * marcador cree que le movieron los datos de sitio.
 */
const DESTINO: Record<string, string> = {
  clientes: "/clientes",
  cotizaciones: "/cotizaciones",
  proveedores: "/proveedores",
  "tipos-proveedor": "/tipos-proveedor",
}

export function RutaComercialVieja() {
  const { vista } = useParams()
  // Sin vista —`/comercial` a secas— o con una que ya no existe, a clientes, que es por
  // donde empieza el trabajo comercial.
  return <Navigate to={DESTINO[vista ?? ""] ?? "/clientes"} replace={true} />
}
